
import { Trans as LingoTrans }  from '@tencent/lingo-sdk/dist/react';
import { initI18n } from './index';
export const Trans = (props: any) => { 
  initI18n();
  return <LingoTrans {...props}/>
};